<!-- <div class="liveContainer">
    <div class="container-fluid" style="background: #0D0D0D;"> -->
<!-- <div class=" mx-auto player-contain">
  <video id="example-video" class="video-js player-video vjs-big-play-centered" autoplay controls preload="none"
    data-setup="{}">
    <source [src]="stream_Url" type="video/mp4" />
  </video>
</div> -->
<!-- </div>
  </div>
 -->
 <!-- <div  class="cursor-pointer " style="z-index: 999;position: absolute;">
  <div class="back" (click)="backToInfo()">
    <i class="fas fa-arrow-alt-left" (click)="backToInfo()"><span class="fs-16 fw-500"> {{'COMMON.BACK' | translate}}</span> </i>
  </div>
</div> -->
<!-- <div class="mx-auto player-contain" *ngIf="!stream_Url"> 
  <video id="example-videoMovie" class="video-js player-video " autoplay controls preload="none"
  data-setup="{}" disablepictureinpicture controlslist="nodownload noplaybackrate">
  </video>
</div>

<div class="mx-auto  player-contain movie-contain" *ngIf="stream_Url" (mouseover)="onMouseOver($event)"> 
  <video id="example-videoMovie"  class="video-js player-video " autoplay controls preload="none"
    data-setup="{}"  controlslist="nodownload noplaybackrate">
    <source [src]="stream_Url" type="video/mp4"/>
    <p class="vjs-no-js">
      To view this video please enable JavaScript, and consider upgrading to a
      web browser that
      <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
    </p>
  </video>
</div> -->

<div class="video-container  responsive-player" >
  <video class="video-container__video player" id="movie-player" style="width: 100%;height: 100%;">
    <source [src]="stream_Url" type="video/mp4"/>
    <track kind="captions" src="caption/subtitles.vtt" srclang="en" label="English" default>
    <div class="d-flex align-item-center justify-content-center" style="border: 2px solid red;">
      <button class="btn btn-primary fs-22"> Play <i class="fa fa-play fs-24"></i></button>
    </div>
  </video>
  <div class="video-container__controls"> 
    <div class="control epg-image" >
      <div class="border-back" (click)="backToInfo()" style="display: flex;justify-content: center;align-items: center; height: 2rem;width: 3rem;">
        <i class="fa fa-arrow-left fs-20"></i>
      </div>
    </div>
    <div class="control video-info">
    <div class="video-title fs-22 pl-4 pr-3 ">{{ videoTitle }}</div>
    </div>
    <div class="d-flex justify-content-center align-item-center">
      <button class="control control--backward">
        <i class="fas fa-backward"></i>
      </button>
      <button class="control control--play paused">
        <img class="fas fa-play" src="./assets/images/nio-icons/play_btn.svg" alt="">
        <i class="fas fa-pause"></i>
      </button>
      <button class="control control--forward">
        <i class="fas fa-forward"></i>
      </button>
      <button class="control control--replay pr-2">
        <i class="fas fa-sync fs-24"></i>
      </button>
    </div>
    <!-- <button class="control control--favorite pr-2" *ngIf="isFavourit" (click)="deleteFavourites()">
      <img src="./assets/images/nio-icons/favourites_like_heart.svg" class="fas fa-heart" alt="">
    </button>
    <button class="control control--favorite pr-2" *ngIf="!isFavourit" (click)="onSaves()">
      <img src="./assets/images/nio-icons/favourites_heart.svg" class="fas fa-heart" alt="">
    </button> -->
    <button class="control control--fullscreen pr-2">
      <img class="fas fa-expand" src="./assets/images/nio-icons/fullscreen_player_icon.svg" alt="">
      <i class="fas fa-compress fs-28" (click)="closeFullscreen()"></i>
    </button>
      <!-- <button class="control control--caption pr-3">
        <img class="fas fa-closed-captioning" src="./assets/images/nio-icons/caption.svg" alt="">
      </button> -->
     <div class="brightness-overlay"></div>

      <button class="control control--volume">
        <div class="control--volume__button">
          <img src="./assets/images/nio-icons/mute_volume.svg" class="fas fa-volume-off" alt="">
          <i class="fas fa-volume-up fs-24"></i>
        </div>
        <input class="control--volume__slider" value="0" type="range" min="0" max="1" step="0.01">
      </button>
      
      <div class="progress">
        <div class="progress__current"></div>
      </div>
      <div class="start-end-time">
       <div class="flex-time">
         <div class="start-time">
           <div class="video-duration  fs-20">{{ videoDuration }}</div>
          </div>
          <div class="end-time">
            <div class="video-duration  fs-20">{{ totalVideoDuration }}</div>
          </div>
        </div>
      </div>
     

        
      
  </div>
</div>
